import { UnavailableProduct, MergedProduct, AlmTokenInfo } from '@types';
import { customParseJwt, getCartCookies } from '@utils';

export const createTitleFromRemovedProductsNames = ((products: UnavailableProduct[]) => {
  if (!products || products.length === 0) return '';
  return products.map((product) => `"${product.name}"`).join(', ');
});

export const createDataForMergeCartError = (
  (products: MergedProduct[]): { displayName: string, productsTitles: string } => {
    const { almToken } = getCartCookies();
    const almInfo = customParseJwt<AlmTokenInfo>(almToken);
    const displayName = almInfo?.given_name && almInfo.given_name !== 'noname' ? ` ${almInfo.given_name}` : '';

    const productsTitles = products.map((product) => `"${product.maName}"`).join(', ');
    return {
      displayName,
      productsTitles,
    };
  }
);
